import React from "react";

const Export = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.874" height="13.874" viewBox="0 0 13.874 13.874">
			<g id="icons8-enlarge" transform="translate(-10.426 -12.629)">
				<path
					id="Path_39654"
					data-name="Path 39654"
					d="M12.34,34.94H7V29.6"
					transform="translate(4.069 -9.019)"
					fill="none"
					stroke="#fff"
					strokeLinecap="round"
					strokeWidth="1"
				/>
				<path
					id="Path_39655"
					data-name="Path 39655"
					d="M29.6,7h5.12v5.12"
					transform="translate(-10.92 6.129)"
					fill="none"
					stroke="#fff"
					strokeLinecap="round"
					strokeWidth="1"
				/>
				<line
					id="Line_478"
					data-name="Line 478"
					x1="12.352"
					y2="12.352"
					transform="translate(11.133 13.443)"
					fill="none"
					stroke="#fff"
					strokeLinecap="round"
					strokeWidth="1"
				/>
			</g>
		</svg>
	);
};

export default Export;
